import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const OgretimUyemizIUCNKongresi2025 = () => {
  const images = [
    'https://fs.hacettepe.edu.tr/fenyeni/resimler/_/_2/b4.jfif',
    'https://fs.hacettepe.edu.tr/fenyeni/resimler/_/_2/b3.jfif',
  ];

  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = useCallback((index) => {
    setCurrentIndex(index);
    setModalOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    document.body.style.overflow = 'unset';
  }, []);

  const nextImage = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  }, [images.length]);

  const prevImage = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  }, [images.length]);

  useEffect(() => {
    const handleKey = (e) => {
      if (!modalOpen) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [modalOpen, closeModal, nextImage, prevImage]);

  return (
    <PageTemplate
      title="Öğretim Üyemiz IUCN Dünya Doğa Koruma Kongresi 2025'e Katıldı"
      subtitle=""
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl -mt-16 relative z-10 mb-16">

          {/* Başlık ve Badge'ler */}
          <div className="mb-8 space-y-3">
            <p className="text-2xl font-bold text-hacettepe-blue italic">IUCN Dünya Doğa Koruma Kongresi 2025</p>
            <div className="flex flex-wrap gap-2">
              <span className="px-4 py-1.5 rounded-full text-sm font-semibold bg-hacettepe-red text-white">Doç. Dr. Baran Yoğurtçuoğlu</span>
              <span className="px-4 py-1.5 rounded-full text-sm font-semibold bg-blue-600 text-white">Abu Dhabi, BAE</span>
              <span className="px-4 py-1.5 rounded-full text-sm font-semibold bg-emerald-600 text-white">9–15 Ekim 2025</span>
            </div>
          </div>

          {/* Metin */}
          <div className="space-y-5 mb-10">
            <p className="text-lg leading-relaxed text-gray-700">
              Fakültemiz Biyoloji Bölümü Öğretim Üyesi Doç. Dr. Baran Yoğurtçuoğlu, Birleşik Arap Emirlikleri'nin Abu Dhabi kentinde düzenlenen küresel ölçekteki en büyük çevre platformlarından biri olan IUCN Dünya Doğa Koruma Kongresi'ne katılım sağladı.
            </p>
            <p className="text-lg leading-relaxed text-gray-700">
              9-15 Ekim 2025 tarihleri arasında gerçekleştirilen kongrede, Türkiye Tabiatını Koruma Derneği (TTKD) adına IUCN İletişim Sorumlusu olarak görev alan Doç. Dr. Baran Yoğurtçuoğlu, doğa koruma politikalarının geleceğini şekillendiren Üye Meclisi (Member's Assembly) oturumlarına aktif katılım göstermiştir. Oturumlarda, ekolojik yıkımın suç sayılması ve sentetik biyoloji politikaları gibi kritik kararları içeren 148 tavsiye ve karar oylanmıştır.
            </p>
            <p className="text-lg leading-relaxed text-gray-700">
              Kongre süresince; IUCN Kırmızı Liste değerlendirme araçları, EICAT (İstilacı Türlerin Çevresel Etki Sınıflandırması) sistemi ve Önemli Biyoçeşitlilik Alanları (KBA) gibi teknik çalıştaylarda yer alan Doç. Dr. Yoğurtçuoğlu, ayrıca IUCN Avrupa Bölge Ofisi Direktörü Boris Erg ile Ulusal Komite toplantılarına ilişkin iş birliği görüşmeleri gerçekleştirmiştir. Kongre sonunda yayımlanan "Abu Dhabi Eylem Çağrısı" (Abu Dhabi Call to Action) ile doğanın insan refahının temeli olarak korunması ve küresel biyoçeşitlilik hedefleri için uluslararası dayanışmanın güçlendirilmesi vurgulanmıştır.
            </p>
          </div>

          {/* Görseller */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {images.map((src, i) => (
              <div
                key={i}
                className="group relative rounded-2xl overflow-hidden shadow-lg border border-gray-100 cursor-pointer"
                onClick={() => openModal(i)}
              >
                <img
                  src={src}
                  alt={`IUCN Kongresi 2025 - ${i + 1}`}
                  className="w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/50 rounded-full p-3">
                    <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                      <div className="w-2 h-2 bg-white rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>

        <div className="text-center mb-16">
          <Link
            to="/haberler"
            className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-gray-800 to-gray-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-300"
          >
            <FaArrowLeft className="mr-3 -ml-1 h-5 w-5 group-hover:-translate-x-1 transition-transform duration-300" />
            Tüm Haberlere Geri Dön
          </Link>
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-95 flex items-center justify-center"
          onClick={closeModal}
        >
          <button onClick={closeModal} className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-60">
            <FaTimes size={24} />
          </button>

          <div className="absolute top-4 left-4 text-white bg-black/50 px-3 py-1 rounded-full text-sm z-60">
            {currentIndex + 1} / {images.length}
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 text-white hover:text-gray-300 bg-black/50 rounded-full p-2 z-60"
          >
            <FaChevronLeft size={20} />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 text-white hover:text-gray-300 bg-black/50 rounded-full p-2 z-60"
          >
            <FaChevronRight size={20} />
          </button>

          <div
            className="max-w-[90vw] max-h-[90vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[currentIndex]}
              alt={`IUCN Kongresi 2025 - ${currentIndex + 1}`}
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
          </div>
        </div>
      )}
    </PageTemplate>
  );
};

export default OgretimUyemizIUCNKongresi2025;
